import { motion, AnimatePresence } from "framer-motion";
import { BadgeCheck } from "lucide-react";

export default function Receipt({ lines, guests }) {
    return (
        <aside data-testid="receipt" className="lg:sticky lg:top-28">
            <div className="bg-paper p-6 font-mono text-sm text-ink shadow-[0_20px_60px_rgba(28,25,23,0.12)] ring-1 ring-border">
                <p className="text-center text-xs uppercase tracking-[0.3em] text-muted-foreground">
                    * Menuforslag *
                </p>
                <div className="my-4 border-t border-dashed border-poelse/20" />
                <AnimatePresence mode="popLayout">
                    {lines.length === 0 ? (
                        <motion.p
                            key="empty"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            className="py-6 text-center text-xs text-muted-foreground"
                        >
                            Vælg en menu for at se din forespørgsel
                        </motion.p>
                    ) : (
                        <ul className="space-y-2.5">
                            <motion.li
                                key="guests"
                                initial={{ opacity: 0, x: -10 }}
                                animate={{ opacity: 1, x: 0 }}
                                className="text-xs font-bold"
                            >
                                {guests} gæster
                            </motion.li>
                            {lines.map((l) => (
                                <motion.li
                                    key={l}
                                    data-testid="receipt-line"
                                    initial={{ opacity: 0, x: -10 }}
                                    animate={{ opacity: 1, x: 0 }}
                                    exit={{ opacity: 0 }}
                                    className="text-xs leading-relaxed"
                                >
                                    + {l}
                                </motion.li>
                            ))}
                        </ul>
                    )}
                </AnimatePresence>
                <div className="my-4 border-t border-dashed border-poelse/20" />
                <p className="text-[11px] leading-relaxed text-muted-foreground">
                    Priser viser vi ikke på siden –
                    <br />
                    Jørgen ringer dig op med et personligt tilbud.
                    <br />
                    Bedre service og bedste priser
                </p>
                <p className="mt-3 flex items-center gap-1.5 text-[11px] font-bold text-ochre">
                    <BadgeCheck className="h-3.5 w-3.5" />
                    100% uforpligtende
                </p>
            </div>
            <div className="zigzag" />
        </aside>
    );
}
